export default __webpack_public_path__ + "static/Fall9-5ef5a1567b654d0f947018883e12ea9c.mp3";